import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Input from "ds/Input";

const ProjectTitle = ({ inputs, handleInputChange }) => {
  const intl = useIntl();

  return (
    <form>
      <Typography.Title tag="h3">
        {intl.formatMessage({
          id: "wizard.project.provisioning.call.project"
        })}
      </Typography.Title>
      <br />
      <Input
        analyticId="title"
        placeholder="Title"
        label="Project title"
        name="title"
        value={inputs.title}
        onChange={elt => handleInputChange(elt)}
        required
      />
    </form>
  );
};

export default ProjectTitle;
